import React from "react"
import { FilteredZooMembershipDto } from "../../Models/FilteredZooConstituentDto"
import { useAccount } from "../../Contexts/AccountContext"
import ZooPassLocalStateUtility from "../../../ZooPass/Utilities/ZooPassLocalStateUtility";

export default ({ membership }: { membership: FilteredZooMembershipDto }) => {
    const {dictionary, household} = useAccount();
        // Format date as "Full Month Day, Year" (e.g., "January 15, 2023")
    const formatDate = (date: Date): string => {
        return date.toLocaleDateString('en-US', {
            month: 'long',   // full month name
            day: 'numeric',  // day of the month
            year: 'numeric'  // full year
        });
    };
        // Format the expiration date
    const formattedExpirationDate = membership.parsedExpirationDate ? 
        formatDate(membership.parsedExpirationDate) : membership.expirationDate;

    const renewPass = () => {
        var data = ZooPassLocalStateUtility.SetInitialState();
        ZooPassLocalStateUtility.SetLocalState({...data, step: 2.01, previousStep: 2, step1Value: 0, step2Value: 1, step2RenewalPassId: membership.id});
        window.location.href = `${window.zooPassUrl}`;
    }
            

    return <div className="col-md-12 col-12 flex-grow-1 d-flex"><div className="card w-100">
            <div className="card-body flex-grow-1">
                <h5 className="card-title">{membership.constituent.displayName}</h5>
                <p className="card-text">{membership.membershipLevel.description}</p>
                <p className="card-text"><b>{dictionary.get('MyAccount:Membership:ExpirationDate') || "Expiration Date"}: </b>{formattedExpirationDate}</p>
                <p className="card-text">{dictionary.get('MyAccount:Membership:Number') || "Membership number"}: {household?.id}</p>
            </div>
        <div className="card-footer bg-white">
            {membership.forRenewal && <button className="btn btn-success" onClick={renewPass}>{dictionary.get('MyAccount:Membership:Renew') || "Renew Membership"}</button>}
            <div className="mt-2"><a className="btn btn-success" href={window.tnewUrl + "/account/update"}>{dictionary.get('MyAccount:Membership:AccountInfo') || "Edit Account Information"}</a></div>
            </div>
        </div>
    </div>
}